import images from './images';

const wines = [
  {
    title: 'Chapel Hill Shiraz',
    price: '$120',
    tags: 'AU | Bottle',
  },
  {
    title: 'Catena Malbec',
    price: '$130',
    tags: 'AR | Bottle',
  },
  {
    title: 'La Vieille Rosé',
    price: '$110',
    tags: 'FR | 750 ml',
  },
  {
    title: 'Rhino Pale Ale',
    price: '$85',
    tags: 'CA | 750 ml',
  },
  {
    title: 'Irish Guinness',
    price: '$75',
    tags: 'IE | 750 ml',
  },
];

const cocktails = [
  {
    title: 'Aperol Spritz',
    price: '$28',
    tags: 'Aperol | Villa Marchesi prosecco | Soda | 30 ml',
  },
  {
    title: "Dark 'N' Stormy",
    price: '$32',
    tags: 'Dark rum | Ginger beer | Slice of lime',
  },
  {
    title: 'Daiquiri',
    price: '$26',
    tags: 'Rum | Citrus juice | Sugar',
  },
  {
    title: 'Old Fashioned',
    price: '$45',
    tags: 'Bourbon | Brown sugar | Angostura Bitters',
  },
  {
    title: 'Negroni',
    price: '$40',
    tags: 'Gin | Sweet Vermouth | Campari | Orange garnish',
  },
];

const entrees = [
  {
    title: 'Seared Scallops',
    price: '$48',
    tags: 'Pan-seared scallops | Citrus beurre blanc | Pea puree | Microgreens',
  },
  {
    title: 'Truffle Risotto',
    price: '$56',
    tags: 'Arborio rice | Black truffles | Parmesan cheese | Truffle oil',
  },
  {
    title: 'Foie Gras Torchon',
    price: '$62',
    tags: 'Foie gras torchon | Brioche toast | Fig compote | Pickled shallots',
  },
  {
    title: 'Tuna Tartare',
    price: '$54',
    tags: 'Diced tuna | Avocado | Cucumber | Soy-lime vinaigrette | Sesame seeds',
  },
  {
    title: 'Beef Carpaccio',
    price: '$58',
    tags: 'Raw beef tenderloin | Arugula | Shaved Parmesan | Truffle oil',
  },
];

const mains = [
  {
    title: 'Filet Mignon',
    price: '$95',
    tags: 'Filet mignon | Red wine reduction | Roasted garlic mashed potatoes | Seasonal vegetables',
  },
  {
    title: 'Roasted Duck Breast',
    price: '$88',
    tags: 'Pan-roasted duck breast | Cherry-port reduction | Wild rice | Sautéed baby carrots',
  },
  {
    title: 'Lobster Thermidor',
    price: '$115',
    tags: 'Lobster meat | Creamy brandy sauce | Parmesan breadcrumb topping | Jasmine rice | Steamed bok choy',
  },
  {
    title: 'Wagyu Beef Burger',
    price: '$98',
    tags: 'Wagyu beef patty | Foie gras | Truffle aioli | Caramelized onions | Brioche bun | Truffle fries',
  },
  {
    title: 'Miso-Glazed Black Cod',
    price: '$110',
    tags: 'Black cod | Miso and sake marinade | Jasmine rice | Steamed bok choy',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'Bib Gourmond',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'AA Hospitality',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Chef',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

export default { wines, cocktails, awards, entrees, mains};